/**
 *
 * NotFoundPage
 *
 */

import React, { memo, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
// import { messages } from './messages';
import Logo from 'assets/images/Logo.svg';
import NoConnection from 'assets/images/NoConnection.webp';
import { Button } from 'core/components/Button/Loadable';
import History from 'core/utils/history';
import EncryptedStorage from 'core/utils/constants/encryptedStorage';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { useAuthenticationSlice } from 'features/Authentication/slice';
import { resetLocalStorage } from 'features/Authentication/slice/saga';
import { useDispatch } from 'react-redux';
import axios from 'axios';

interface Props {}

export const LeftComponent = () => {
  return (
    <div className="col-span-4 h-[100vh] bg-primary-main">
      <div className="w-full py-[4%] h-[20%]">
        <img src={Logo} alt="LOGO" className="h-[80%] ml-[5%]" />
      </div>
      <div className="w-full h-[80%] flex items-center">
        <img src={NoConnection} alt="Some Error Occured" />
      </div>
    </div>
  );
};

export const NotFoundPage = memo((props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();
  const authData = useAuth();
  const dispatch = useDispatch();
  const { actions } = useAuthenticationSlice();

  const handleLogout = () => {
    if (authData?.USER_LOGIN_ID) {
      dispatch(actions.logoutStart({
        USER_LOGIN_ID: authData.USER_LOGIN_ID,
        cancelToken: axios.CancelToken.source(),
      }));
      return;
    }

    resetLocalStorage();
    dispatch(actions.clearState());
    window.location.href = '/';
  };

  const [type, settype] = React.useState<string>('Go Back');
  useEffect(() => {
    if (EncryptedStorage.getItem('_UFT_') === null) {
      History.navigate('/login');
      settype('Login');
    }
  }, []);

  return EncryptedStorage.getItem('_UFT_') !== null ? (
    <div className="grid grid-cols-12 h-[100vh]">
      <LeftComponent />
      <div className="col-span-8 h-[100vh] bg-[url('/src/features/Authentication/assets/BackGroundAuth.webp')] bg-cover">
        <div className="w-full h-full px-[15%] py-[22.5%]">
          <h1 className="font-bold text-9xl mb-[4%]">404</h1>
          <p className="font-regular text-neutral-60 text-4xl">
            Oooops, Page not found
          </p>
          <p className="text-xl my-[4%] font-extralight text-neutral-60">
            The page you are looking for doesn’t exist or an other error
            occurred, go back to home page.
          </p>
          <div className="flex gap-3">
            <Button
              type="primary"
              label={type}
              // TODO - Add Back to History
              onClick={() =>
                type === 'Login' ? History.navigate('/') : History.navigate('/')
              }
            />
            <Button
              button
              type="outlined"
              label="Logout"
              onClick={handleLogout}
            />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
});

const Div = styled.div``;
